export default {
  getHead: () => {
    return [{name: '시설물명'}, {name: '종류'}, {name: '종별'}, {name: '안전 등급'}, {name: '점검 결과'}, {name: '부서명'}, {name: '작성일'}]
  } ,
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).stdInfo.field_name // 시설물명
        case 1: return func.getContent(value).inputB_7 // 종류
        case 2: return func.getContent(value).inputB_9 // 종별
        case 3: return func.getContent(value).inputB_10 // 안전등급
        case 4: return func.getContent(value).inputC_1 // 점검결과
        case 5: return func.getContent(value).stdInfo.section // 부서명
        case 6: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType,  searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    switch (nav.value.searchType) {
      case '시설물명': return ['content$body.stdInfo.field_name*%[:default_skw]%']
      case '종류': return ['content$body.inputB_7*%[:default_skw]%']
      case '종별': return ['content$body.inputB_9*%[:default_skw]%']
      case '안전 등급': return ['content$body.inputB_10*%[:default_skw]%']
      case '점검 결과': return ['content$body.inputC_1*%[:default_skw]%']
      case '부서명': return ['content$body.stdInfo.section*%[:default_skw]%']
    }
    return []
  },
}
